import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import {ANIMATION_DURATION} from '../constants';

const CLASS_NAME = 'slx-product-wizard-label';

export default createReactClass({
	displayName: 'ProductWizardLabel',
	highlighting: false,

	propTypes: {
		label: PropTypes.string,
		count: PropTypes.number,
		width: PropTypes.number,
		onClick: PropTypes.func,
		isCollapsed: PropTypes.bool,
		isDisabled: PropTypes.bool,
		isSelected: PropTypes.bool,
		isDeselectable: PropTypes.bool,
		isQuasiSelected: PropTypes.bool,
		isLoading: PropTypes.bool,
		highlight: PropTypes.bool,
		modificators: PropTypes.array
	},

	getDefaultProps() {
		return {
			count: null,
			width: null,
			isCollapsed: false,
			isDisabled: false,
			isSelected: false,
			isDeselectable: false,
			isQuasiSelected: false,
			isLoading: false,
		};
	},

	onClick() {
		this.props.onClick();
	},

	render() {
		let className = CLASS_NAME
			+ (this.props.isCollapsed ? ' collapsed' : '')
			+ (this.props.isDisabled ? ' disabled' : '')
			+ (this.props.isSelected ? ' selected' : '')
			+ (this.props.isDeselectable ? ' deselectable' : '')
			+ (this.props.isQuasiSelected ? ' quasi-selected' : '')
			+ (this.props.isLoading ? ' loading' : '');

		if (!this.highlighting && this.props.highlight) {
			className += ' highlight';
			this.highlighting = true;
			setTimeout(() => this.highlighting = false, ANIMATION_DURATION);
		}
		if (this.highlighting) {
			className += ' highlight';
		}
		if (this.props.modificators) {
			const classes = this.props.modificators.map(mod => `${CLASS_NAME}--${mod}`);
			className += ` ${classes.join(' ')}`;
		}

		const width = this.props.width ? {width: this.props.width} : {};

		let count = null;
		if (this.props.count !== null) {
			count = (
				<span>(<span className={`${CLASS_NAME}__count`}>{this.props.count}</span>)</span>
			);
		}

		return (
			<li
				className={`${CLASS_NAME}__wrap`}
				style={width}
			>
				<div
					className={className}
					onClick={() => this.onClick()}
				>
					{this.props.isDeselectable ? <button className={`${CLASS_NAME}__close`}/> : null}
					{this.props.label}&nbsp;
					{count}
				</div>
			</li>
		);
	}
});
